module.exports = __webpack_public_path__ + "img/sales-terms-intro.8aa6e017.png";